import type { ApiIntakeIntentFilterOption } from '#/api/types/ApiIntakeIntentFilterOption';
import type { I18nFn } from '#/i18n/types/I18nFn';

export const INTAKE_INTENT_FILTER_CHECKBOX_OPTIONS = (
  i18n: I18nFn,
): { name: ApiIntakeIntentFilterOption; label: string }[] => [
  { name: 'LOOKING_FOR_JOB', label: i18n('Job or Internship') },
  { name: 'VOLUNTEER', label: i18n('Volunteer') },
  { name: 'POST_JOB_OR_OTHER_OPP', label: i18n('Post on Idealist') },
  { name: 'NO_RESPONSE', label: i18n('No response') },
];
